let popoverCallbacks : any = {};


export class PopoverService {
  public static registerPopover(fieldId : string, callback) {
    popoverCallbacks[fieldId] = callback;
  }

  public static unRegisterPopover(fieldId : string) {
    popoverCallbacks[fieldId] = undefined;
    delete popoverCallbacks[fieldId];
  }

  public static closeAllPopovers(fieldId? : string) {
    Object.keys(popoverCallbacks).map((popoverField) => {
      if (popoverCallbacks[popoverField]) {
        if (fieldId !== undefined && fieldId === popoverField) {
          return;
        }
        popoverCallbacks[popoverField](popoverField);
      }
    });
  }
}